export default __webpack_public_path__ + "static/media/MLLOGO.f03e6e1f.png";